<template>

  <div
    v-if="conversation"
    :class="{'box-loading': loading}"
    class="mb-3">

    <label class="d-block text-uppercase text-muted small font-weight-bold mb-1">{{ $t('Candidate') }}</label>

    <!-- associated candidate: the list of suggestions is not shown anymore -->
    <div
      v-if="candidate"
      class="contact-candidate-row d-flex align-items-center py-1">
      <a
        href="javascript:void(0)"
        class="d-flex align-items-center flex-grow-1 text-body"
        @click="openCandidate(candidate)">
        <Avatar
          class="flex-shrink-0 mr-2"
          :src="photo(candidate)"
          :name="candidate.name"
          size="32px"
          radius="16px" />
        <span class="text-truncate">{{ candidate.name || $t('No name') }}</span>
      </a>
      <button
        type="button"
        class="btn btn-link btn-sm text-muted p-0 ml-2"
        :title="$t('Unlink candidate')"
        @click="associate(null)">
        <i class="fa-solid fa-link-slash"></i>
      </button>
    </div>

    <!-- no candidate yet: suggestions found by the conversation contact address.
    the key rebuilds the list (and its search) on another conversation -->
    <ContactCandidateFieldList
      v-else
      :key="conversation._id"
      :conversation="conversation"
      @associate="associate" />

  </div>

</template>

<script>
import config from '@/config'
import Avatar from '@/components/Parts/Avatar'
import ContactCandidateFieldList from './ContactCandidateFieldList'

export default {
  name: 'ContactCandidateField',
  components: {
    Avatar,
    ContactCandidateFieldList
  },
  props: {
    conversation: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    // populated by the api ({ _id, name, photo_media_url }) when associated
    candidate () {
      const value = this.conversation && this.conversation.candidate_id
      return value && value._id ? value : null
    }
  },
  methods: {
    /*
    photo
    the candidate default picture is a placeholder image: dropping it lets the
    Avatar fall back to the initials
    */
    photo (candidate) {
      const url = candidate && candidate.photo_media_url
      return url && !url.includes(config.default_image_url.candidate) ? url : null
    },
    /*
    associate
    links the conversation to a candidate, or unlinks it when the id is null.
    the name goes along because the update rewrites the editable fields
    */
    associate (candidateId) {
      this.loading = true

      const data = {
        candidate_id: candidateId
      }

      this.$store
      .dispatch('updateConversation', { id: this.conversation._id, data: data })
      .then(() => {
        this.$store.dispatch('setWarn', { status: 'success' })
        this.$emit('updated')
      })
      .catch(() => {
        this.$store.dispatch('setWarn', { status: 'error' })
      })
      .finally(() => {
        this.loading = false
      })
    },
    /*
    openCandidate
    */
    openCandidate (candidate) {
      this.$openCandidateModal(candidate._id)
    }
  }
}
</script>

<style scoped>
/* let the name shrink so text-truncate works inside the flex row */
.contact-candidate-row a,
.contact-candidate-row .text-truncate {
  min-width: 0;
}

.contact-candidate-row a:hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/contact/ContactCandidateField.vue